export enum ProdutoStatus {
    Ativo = 1,
    Inativo = 2,
}

export enum ProdutoTipo {
    Simples = 'S',
    Kit = 'K',
    Fabricado = 'F',
    MateriaPrima = 'M',
    Servico = 'E',
    ComVariacao = 'C',
    Variacao = 'V',
    ComAdicional = 'A',
}

export enum ProdutoNcmStatus {
    Valido = 'V',
    Invalido = 'I',
    Pendente = 'P',
    Desconhecido = '',
}
